<template>
    <mobile-header-foot class="mobile-header-foot--basic">
        <template v-for="(_, slotName) in $slots" #[slotName]>
            <slot :name="slotName" />
        </template>
    </mobile-header-foot>
</template>

<script>
import MobileHeaderFoot from "@/sets/styles/headers/mobile-header-foot.vue";

export default {
    props: {},
    components: {
        MobileHeaderFoot,
    },
    data: () => {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped>
.mobile-header-foot--basic{
    background-color: var(--v-grey-lighten5);
    border-bottom: 1px solid var(--v-grey-lighten3);
}
</style>
